export class Constants{
    static readonly MI_PERFIL = "Mi Perfil";
    static readonly SOPORTE= "Soporte";
    static readonly ACERCA_DE = "Acerca de";
    static readonly AYUDA = "Ayuda";
    static readonly CONFIGURACION = "Configuración";
    static readonly SALIR = "Salir";
    static readonly MANUAL_USUARIO = "Manual de usuario";
    static readonly FAQ = "Preguntas frecuentes";
}